export type XTgFeature = 'download' | 'copy' | 'forward';

const STORAGE_KEY = 'x-tg-download.features.v1';
const LAUNCHER_KEY = 'x-tg-download.launcher-visible.v1';
const defaults: Record<XTgFeature, boolean> = {
  download: true,
  copy: true,
  forward: true
};

function read(): Record<XTgFeature, boolean> {
  try {
    return {...defaults, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')};
  } catch {
    return {...defaults};
  }
}

export function isFeatureEnabled(feature: XTgFeature): boolean {
  return read()[feature] !== false;
}

export function setFeatureEnabled(feature: XTgFeature, enabled: boolean): void {
  const state = read();
  state[feature] = enabled;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  window.dispatchEvent(new CustomEvent('x-tg-download:settings', {detail: state}));
}

export function getFeatureSettings(): Record<XTgFeature, boolean> {
  return read();
}

export function isLauncherVisible(): boolean {
  return localStorage.getItem(LAUNCHER_KEY) !== 'false';
}

export function setLauncherVisible(visible: boolean): void {
  localStorage.setItem(LAUNCHER_KEY, String(visible));
  window.dispatchEvent(new CustomEvent('x-tg-download:launcher', {detail: {visible}}));
}
